import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import "core-js/modules/es6.number.constructor.js";
import React from 'react';
import { Impression } from '@nerdwallet/analytics/react/impression';
import { gql } from '@nerdwallet/apollo';
import { ContentPageHeader } from '@nerdwallet/currency';
import mapWordPressProps from './mappings/wordpress';

var mapWordPressEntityToProps = function mapWordPressEntityToProps(props) {
  return mapWordPressProps(props);
};

var WordPressContentPageHeader = function WordPressContentPageHeader(props) {
  var enableAnalytics = props.enableAnalytics;
  var mappedProps = mapWordPressEntityToProps(props);
  return /*#__PURE__*/React.createElement(Impression, {
    enabled: !!enableAnalytics,
    entityName: "wordpress_content_page_header",
    eventType: "content_element_impression",
    payload: {
      section_name: 'content_page_header',
      section_position: enableAnalytics === null || enableAnalytics === void 0 ? void 0 : enableAnalytics.sectionPostion,
      content_id: Number(mappedProps.id),
      content_source: 'wp',
      content_id_type: 'post'
    }
  }, /*#__PURE__*/React.createElement(ContentPageHeader, mappedProps));
};

WordPressContentPageHeader.defaultProps = {
  enableAnalytics: false
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  WordPressContentPageHeader.propTypes = {
    /**
     * Flag indicating whether or not to enable bedrock analytics tracking.
     */
    enableAnalytics: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
      onClick: PropTypes.bool,
      onHover: PropTypes.bool,
      sectionPostion: PropTypes.number
    })]),

    /**
     * Vanilla object from the WordPress API. Mapped and passed
     * down to ContentPageHeader. See styleguide.jsx for an
     * example of the shape.
     */
    wordPressEntity: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types

  };
}

WordPressContentPageHeader.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment WordPressContentPageHeader on ContentPageHeaderInterface {\n    __typename\n    advertiserDisclosureType\n    authors {\n      name\n      link\n    }\n    editorialDisclaimerType\n    id\n    primaryCategory {\n      name\n    }\n    showAdvertiserDisclosure\n    showAuthorByline\n    showEditorialDisclaimer\n    title\n\n    ... on PostWithFeaturedImageInterface {\n      # Give it a different name so it doesn't conflict with featuredMedia coming from a fragment\n      featuredImage: featuredMedia {\n        id\n        altText\n\n        mediaDetails {\n          id\n          sizes(\n            sizes: [\n              \"bb-article\"\n              \"primary-xxxl\"\n              \"primary-xxl\"\n              \"primary-xl\"\n              \"primary-l\"\n              \"primary-m\"\n              \"primary-s\"\n              \"primary-xs\"\n              \"primary-xxs\"\n              \"full\"\n            ]\n          ) {\n            sourceUrl\n            width\n            height\n            size\n          }\n        }\n      }\n    }\n\n    ... on PostWithReviewerInterface {\n      reviewedBy {\n        name\n        url: link\n      }\n    }\n\n    ... on Article {\n      hideFeaturedImage\n      dateTimeDisplayDate: displayDate\n      stringSynopsis: synopsis\n    }\n\n    ... on Roundup {\n      eyebrowText\n      formattedDisplayDate: displayDate\n      structuredContentSynopsis: synopsis\n    }\n  }\n"])));
export default WordPressContentPageHeader;